var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148773",
    "data-name": "Rectangle 148773",
    width: 20,
    height: 20,
    transform: "translate(0.315)",
    fill: "#0c0c0b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "left-arrow",
    transform: "translate(-0.315)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12052",
    "data-name": "Group 12052",
    transform: "translate(2.193 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10150",
    "data-name": "Path 10150",
    d: "M-17133.605-1894.336a.724.724,0,0,0,.076,0,.749.749,0,0,0,.67-.822,10.4,10.4,0,0,0-2.068-4.833,10.389,10.389,0,0,0-4.061-3.166,15.015,15.015,0,0,0-6.127-1.169c-.355,0-.719.009-1.086.028a.752.752,0,0,0-.713.786.751.751,0,0,0,.75.713h.037c.352-.018.7-.026,1.035-.026,4.041,0,7.057,1.259,8.975,3.751a8.947,8.947,0,0,1,1.766,4.071A.75.75,0,0,0-17133.605-1894.336Z",
    transform: "translate(17147.662 1907.158)",
    fill: "#0c0c0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10151",
    "data-name": "Path 10151",
    d: "M-17144.076-1955.988a.751.751,0,0,0,.531-.22.753.753,0,0,0,0-1.061l-2.26-2.258,2.26-2.259a.753.753,0,0,0,0-1.061.752.752,0,0,0-1.062,0l-2.789,2.789a.749.749,0,0,0-.219.53.749.749,0,0,0,.219.53l2.789,2.789A.751.751,0,0,0-17144.076-1955.988Z",
    transform: "translate(17147.615 1963.066)",
    fill: "#0c0c0b"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.3385030a.svg";
export { ForwardRef as ReactComponent };